"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BillingAddressToJSON = exports.BillingAddressFromJSONTyped = exports.BillingAddressFromJSON = exports.instanceOfBillingAddress = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the BillingAddress interface.
 */
function instanceOfBillingAddress(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfBillingAddress = instanceOfBillingAddress;
function BillingAddressFromJSON(json) {
    return BillingAddressFromJSONTyped(json, false);
}
exports.BillingAddressFromJSON = BillingAddressFromJSON;
function BillingAddressFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': !(0, runtime_1.exists)(json, 'name') ? undefined : json['name'],
        'street': !(0, runtime_1.exists)(json, 'street') ? undefined : json['street'],
        'city': !(0, runtime_1.exists)(json, 'city') ? undefined : json['city'],
        'region': !(0, runtime_1.exists)(json, 'region') ? undefined : json['region'],
        'postalCode': !(0, runtime_1.exists)(json, 'postal_code') ? undefined : json['postal_code'],
        'taxRegion': !(0, runtime_1.exists)(json, 'tax_region') ? undefined : json['tax_region'],
    };
}
exports.BillingAddressFromJSONTyped = BillingAddressFromJSONTyped;
function BillingAddressToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
        'street': value.street,
        'city': value.city,
        'region': value.region,
        'postal_code': value.postalCode,
        'tax_region': value.taxRegion,
    };
}
exports.BillingAddressToJSON = BillingAddressToJSON;
